export enum ModeOuvertureAbsence {
	AbsenceSalarieParGestionnaire = 0,
	AbsenceSalarieParSalarie = 1,
	AbsenceCollectiveParGestionnaire = 2
}



// WEBPACK FOOTER //
// ./src/shared/models/AbsenceEnum.ts